import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./NavbarComponents.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../redux/features/searchCategorySlice";

const NavbarTopLinks = () => {
  const lang = useSelector((state) => state.language.lang);
  const { categories } = useSelector((state) => state.categories);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const activeCategory = queryParams.get("parent_category_id");

  const topCategories = categories.slice(0, 4);

  useEffect(() => {
    // if (!categories || categories.length === 0) {
    dispatch(fetchCategories(lang));
    // }
  }, [dispatch, lang]);

  const handleCategoryClick = (categoryId) => {
    navigate(`/shops?parent_category_id=${categoryId}&category_id=""`);
  };

  const handleScrollToCarousel = () => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollToCarousel: true } });
    } else {
      const element = document.getElementById("home-carousel");
      element?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="navbar-container">
      <ul className="nav flex-nowrap w-100" style={{ minWidth: 0 }}>
        {topCategories.map((category) => (
          <li
            key={category.id}
            className="flex-grow-1 text-center px-2"
            style={{ minWidth: 0, overflow: "hidden" }}
          >
            <button
              className={`link-style-custom-design border-0 ${activeCategory == category.id ? "active-category" : ""
                }`}
              style={{
                display: "inline-block",
                maxWidth: "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                background: "transparent",
                fontWeight: 600,
                padding: "4px 6px",
                verticalAlign: "middle"
              }}
              title={category.title}
              onClick={() => handleCategoryClick(category.id)}
            >
              {category.title}
            </button>
          </li>
        ))}

        <li className="flex-grow-1 text-center px-2" style={{ minWidth: 0, overflow: "hidden" }}>
          <button
            className={`link-style-custom-design border-0 text-truncate w-100`}
            style={{
              display: "block",
              background: "transparent",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontWeight: 600,
              padding: "4px 6px"
            }}
            onClick={handleScrollToCarousel}
          >
            All
          </button>
        </li>
      </ul>
    </div>
  );
};

export default NavbarTopLinks;
